import auth from "../middleware/auth";
import isColaborador from "../middleware/isColaborador";

const Home = () => import("../components/Views/Home.vue");
const NewNotificacao = () => import("../components/Views/Notificacao/Form.vue");
const MeusEnvios = () =>
  import("../components/Views/Notificacao/MeusEnvios");
const ListNotificacoes = () =>
  import("../components/Views/Notificacao/List.vue");

const breadcrumb = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Notificação", link: "/notificacao" }
];

const notificacao = [
  {
    path: "/notificacao",
    component: Home,
    children: [
      {
        path: "/notificacao/meus-envios",
        component: MeusEnvios,
        name: "Meus Envios",
        meta: {
          middleware: [auth, isColaborador],
          breadcrumb
        }
      },
      {
        path: "/notificacao/new",
        component: NewNotificacao,
        name: "Nova Notificação",
        meta: {
          middleware: [auth, isColaborador],
          breadcrumb
        }
      },
      {
        path: "/notificacao",
        component: ListNotificacoes,
        name: "Minhas Notificação",
        meta: {
          middleware: auth,
          breadcrumb
        }
      }
    ]
  }
];

export default notificacao;



// WEBPACK FOOTER //
// ./src/routes/notificacao.js